import React, { useState } from 'react';
import './RewardInfoBox.css';

const RewardInfoBox: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className={`reward-info-box ${isExpanded ? 'expanded' : ''}`}>
      <button 
        className="reward-info-trigger"
        onClick={() => setIsExpanded(!isExpanded)}
        aria-label="How the game works"
      >
        <span className="info-icon">ℹ️</span>
        <span className="info-label">How the game works</span>
      </button>
      
      {isExpanded && (
        <div className="reward-info-content">
          <div className="reward-info-header">
            <h4>How Rewards Are Calculated</h4>
            <button 
              className="close-btn"
              onClick={() => setIsExpanded(false)}
              aria-label="Close"
            >
              ×
            </button>
          </div>
          
          <div className="reward-simple-explanation">
            <div className="explanation-step">
              <span className="step-bullet">1.</span>
              <span>Investments are added: <strong>Your + Partner</strong></span>
            </div>
            <div className="explanation-step">
              <span className="step-bullet">2.</span>
              <span>Pool grows by <span className="highlight-green">1.5x</span></span>
            </div>
            <div className="explanation-step">
              <span className="step-bullet">3.</span>
              <span>Split equally: <span className="highlight-blue">÷ 2</span></span>
            </div>
            <div className="explanation-step">
              <span className="step-bullet">4.</span>
              <span>Add market fluctuation: <span className="highlight-orange">+(-3 to +3)</span> <span className="fluctuation-note">(different per partner)</span></span>
            </div>
            <div className="explanation-step">
              <span className="step-bullet">5.</span>
              <span><strong>Final reward = Round earning + Not invested coins</strong></span>
            </div>
          </div>
          
          <div className="reward-example-simple">
            <div className="example-title-simple">Example:</div>
            <div className="example-flow">
              <div><strong>8</strong> + <strong>8</strong> = <strong>16</strong></div>
              <div className="example-arrow-small">↓ ×1.5</div>
              <div><strong>24</strong> ÷ 2 = <strong>12</strong> each</div>
              <div className="example-arrow-small">↓ +(-3 to +3)</div>
              <div>Round earnings</div>
              <div className="example-arrow-small">↓ + Not invested coins</div>
              <div><strong>Final reward</strong></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RewardInfoBox;

